export default __webpack_public_path__ + "static/media/add.0ab69002.svg";